import React from 'react';
import { FONTS } from 'styles/theme';
import { LANDING_ASSETS } from 'constants/storefrontAssets';

// Full-bleed "Square Fare / <subtitle>" banner shared by the meal plan
// and the menu. Text sits in a padded inner block so it lines up with the content
// below instead of running to the window edge. `children` render under the title.
const PageHero = ({ subtitle, backgroundImage = LANDING_ASSETS.headerBg, backgroundPosition = 'center', marginBottom = 0, children }) => (
    <div style={{
        backgroundImage: `url("${backgroundImage}")`,
        backgroundSize: 'cover',
        backgroundPosition,
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        minHeight: 'clamp(200px, 26vh, 300px)',
        display: 'flex',
        alignItems: 'center',
        marginBottom,
    }}>
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(90deg, rgba(30,28,26,0.62) 0%, rgba(30,28,26,0.45) 55%, rgba(30,28,26,0.28) 100%)',
            zIndex: 1,
        }} />
        <div style={{
            position: 'relative',
            zIndex: 2,
            width: '100%',
            maxWidth: '1320px',
            margin: '0 auto',
            padding: '0 clamp(20px, 4vw, 40px)',
            boxSizing: 'border-box',
        }}>
            <h1 style={{
                margin: '0 0 4px 0',
                color: '#ffffff',
                fontFamily: FONTS.serif,
                fontWeight: 700,
                lineHeight: 1.1,
                fontSize: 'clamp(28px, 5vw, 52px)',
            }}>
                Square Fare
            </h1>
            <h1 style={{
                margin: '0 0 14px 0',
                color: '#ffffff',
                fontFamily: FONTS.serif,
                fontWeight: 700,
                lineHeight: 1.1,
                fontSize: 'clamp(20px, 4vw, 42px)',
            }}>
                {subtitle}
            </h1>
            {children}
        </div>
    </div>
);

export default PageHero;
